var map = {
	"./beattheclock/1.gif": 1120,
	"./beattheclock/1.png": 5453,
	"./beattheclock/2.gif": 5426,
	"./beattheclock/3.gif": 3756,
	"./escapethemolecano/1.png": 3166,
	"./escapethemolecano/2.png": 8728,
	"./escapethemolecano/3.png": 8432,
	"./magicswampfrogs/1.gif": 3472,
	"./magicswampfrogs/1.png": 8301,
	"./magicswampfrogs/2.gif": 1600,
	"./magicswampfrogs/2.png": 4337,
	"./other/1.png": 1603,
	"./other/2.png": 8146,
	"./other/3.png": 7251,
	"./other/4.png": 4350,
	"./other/5.png": 669,
	"./other/6.png": 3112,
	"./other/7.png": 741,
	"./percivalthepossessedpumpkin/1.gif": 1703,
	"./percivalthepossessedpumpkin/1.png": 3325,
	"./percivalthepossessedpumpkin/2.gif": 4631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1147;